import { AccountCancelOutlineIcon } from './AccountCancelOutlineIcon';

/**
 * author: Simran
 * id D2CDB839-C734-46EA-A4DE-085CBF29DD0F
 * name account-cancel-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-cancel-outline.svg
 * tags
 * - Account / User 
 */
export const UserCancelOutlineIcon = AccountCancelOutlineIcon;
export default UserCancelOutlineIcon